import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { StyledList, StyledListItem } from './CustomersListy.styles';
import {
  clientActionsListItemShape,
  clientDataShape,
} from '../../helpers/clientDataPropTypes';
import { isDelegated } from '../../helpers/permissions';
import Card from '../../components/Card/Card';
import { StyledButton } from './SelectCustomerView.styles';

const CustomersList = ({
  title,
  items,
  'data-testid': testId,
  clientData = null,
  online,
  onLinkClick,
  tileLines,
  titleLines = 2,
  showPagination,
}) => {
  const { t } = useTranslation();
  const [sortedItems, setSortedItems] = useState([]);
  const [limit, setLimit] = useState(showPagination ? 10 : 100000);

  useEffect(() => {
    setSortedItems(items);
  }, [items, clientData, online]);

  return (
    <>
      {title && title()}
      <StyledList data-testid={testId}>
        {sortedItems
          .slice(0, limit)
          .map(
            ({
              id,
              actionId,
              actionDone,
              visitAddress: { name, street, city, postcode },
              distance,
              lat,
              lng,
              clientNumber,
              owned,
              access,
              department,
            }) => {
              const address = [street, city, postcode]
                .filter(Boolean)
                .join(', ');

              return (
                <StyledListItem
                  key={actionId || id}
                  disabled={actionDone && isDelegated(access)}
                >
                  <Card
                    id={id}
                    clientDetails={{
                      name,
                      address,
                      distance,
                      lat: lat?.toString(),
                      lng: lng?.toString(),
                      clientNumber,
                      department,
                    }}
                    tileLines={tileLines}
                    titleLines={titleLines}
                    owned={owned}
                    access={access}
                    onLinkClick={onLinkClick}
                  />
                </StyledListItem>
              );
            }
          )}
        {showPagination && sortedItems.length > limit && (
          <StyledButton
            theme="primary"
            onClick={() => {
              setLimit(limit + 10);
            }}
          >
            {t('customer_list_show_more')}
          </StyledButton>
        )}
      </StyledList>
    </>
  );
};

CustomersList.propTypes = {
  title: PropTypes.func,
  items: PropTypes.arrayOf(clientActionsListItemShape),
  'data-testid': PropTypes.string,
  online: PropTypes.bool,
  onLinkClick: PropTypes.func,
  tileLines: PropTypes.arrayOf(PropTypes.string),
  titleLines: PropTypes.number,
  clientData: clientDataShape,
  showPagination: PropTypes.bool,
};

export default CustomersList;
